export default {
  title: 'Create a plan',
  subtitle: 'Start from a blank plan or let a template fill in the dates and budget for you.',
  templates: 'Start from a template',
  loadingTemplates: 'Loading templates from the model report...',
  close: 'Close',
  choosePeriod: 'Choose the period for "{option}".',
  startMonth: 'Start month',
  endMonth: 'End month',
  startDate: 'Start date',
  endDate: 'End date',
  selectedPeriod: 'Selected period',
  pickStart: 'Pick the start',
  pickEnd: 'pick the end',
  back: 'Back',
  continue: 'Continue'
}
